import * as Sentry from "@sentry/react";
import { QueryClientProvider } from "@tanstack/react-query";
import { ApiHttpClass } from "byzantine/src/ApiHttp";
import jsonFromDocument from "cerulean/src/JsonFromDocument";
import { NotificationContextProvider } from "cerulean/src/NotificationContext";
import React, { Suspense } from "react";
import {
  RouterProvider,
  createBrowserRouter,
  createRoutesFromChildren,
  matchRoutes,
  useLocation,
  useNavigationType,
} from "react-router-dom";
import { queryClient } from "../api";
import { CSRF_TOKEN } from "./csrf";
import { ROUTES } from "./routes";
import { FlashMessagesHandler } from "@components/FlashMessagesHandler";

const sentryConfig = jsonFromDocument("sentry-config");

if (sentryConfig) {
  Sentry.init({
    ...jsonFromDocument("sentry-config"),
    integrations: [
      Sentry.reactRouterV7BrowserTracingIntegration({
        useEffect: React.useEffect,
        useLocation,
        useNavigationType,
        createRoutesFromChildren,
        matchRoutes,
      }),
      Sentry.replayIntegration({
        maskAllInputs: true,
        maskAllText: true,
      }),
    ],
    tracesSampleRate: 1.0,
  });
  Sentry.setTag("tenant", sentryConfig.tenant || "unknown_tenant");
  Sentry.setTag("application", "staff");
}

const router = (
  sentryConfig ? Sentry.wrapCreateBrowserRouterV7(createBrowserRouter) : createBrowserRouter
)(ROUTES);

export default function App() {
  React.useEffect(() => {
    ApiHttpClass.csrfToken = CSRF_TOKEN;
  }, []);

  return (
    <NotificationContextProvider>
      <FlashMessagesHandler />
      <QueryClientProvider client={queryClient}>
        <Suspense fallback={null}>
          {/* woah there, enterprising young engineer! this is a load-bearing div,
           * please don't remove it. See this issue for more details:
           * https://github.com/remix-run/react-router/issues/11110 */}
          <div>
            <RouterProvider router={router} />
          </div>
        </Suspense>
      </QueryClientProvider>
    </NotificationContextProvider>
  );
}
